<div *ngIf="!notLandingHeader; else nonAuthHeader">
	<div class="content ml-3 mr-3">
		<div class="logo " routerLink="/">
			<img class="logo-txt" src="../../../../assets/images/anti-fraud.png" />
			<img
				class="logo-no-txt ml-2"
				src="../../../../assets/images/anti-fraud-no-txt.png"
			/>
		</div>

		<div class="user-project">
			<p class="dark-paragraph mr-4" routerLink="/about-project">
				Për Projektin
			</p>
			<div class="header-container ml-2 ml-sm-0 ">
				<nb-layout-header>
					<nb-user
						[name]="user?.firstName + ' ' + user?.lastName"
						title="Prisig"
						[nbContextMenu]="items"
						nbContextMenuTag="my-context-menu"
					>
						<button
							[nbContextMenu]="items"
							nbContextMenuPlacement="right"
						></button>
					</nb-user>
				</nb-layout-header>
			</div>
		</div>
	</div>
</div>

<ng-template #nonAuthHeader>
	<div class="nonAuth d-flex align-items-center" routerLink="/">
		<img src="../../../../assets/images/anti-fraud.png" />
		<p class="dark-paragraph mr-4" routerLink="/about-project">
			Për Projektin
		</p>
	</div>
</ng-template>
